import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/solution/banner.png'


const _hoisted_1 = {
  key: 0,
  class: "solution"
}
const _hoisted_2 = { class: "common-module" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "solution-case" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "image" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MyHeader = _resolveComponent("MyHeader")!
  const _component_MyPage = _resolveComponent("MyPage")!
  const _component_CommonFooter = _resolveComponent("CommonFooter")!
  const _component_DetailPage = _resolveComponent("DetailPage")!

  return (_ctx.view === 'list')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_MyHeader, { currentMenuIndex: 1 }),
        _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"banner\" data-v-58b07b81><img src=\"" + _imports_0 + "\" alt=\"\" data-v-58b07b81><div class=\"text\" data-v-58b07b81><div class=\"text-zh\" data-v-58b07b81><span data-v-58b07b81>颠覆传统</span><div class=\"dot\" data-v-58b07b81></div><span data-v-58b07b81>面向智能化领域</span></div><div class=\"text-en\" data-v-58b07b81><div class=\"line\" data-v-58b07b81></div><span data-v-58b07b81>Subvert tradition and intelligentization</span><div class=\"line\" data-v-58b07b81></div></div></div></div>", 1)),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.solutionModule, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(_ctx.currnetSolutionModuleIndex === index ? 'active-item common-module-item' : 'common-module-item'),
              key: index,
              onClick: ($event: any) => (_ctx.currnetSolutionModuleIndex = index)
            }, _toDisplayString(item), 11, _hoisted_3))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.solutionList, (item, index) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              class: "solution-case-item",
              key: index,
              onClick: ($event: any) => (_ctx.jumpSolutionDetail(item.key))
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  src: item.img,
                  alt: ""
                }, null, 8, _hoisted_7)
              ]),
              _createElementVNode("div", _hoisted_8, _toDisplayString(item.title), 1),
              _createElementVNode("div", _hoisted_9, _toDisplayString(item.content), 1),
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "more" }, "更多", -1))
            ], 8, _hoisted_5)), [
              [_vShow, Math.ceil((index + 1 ) / 6) === _ctx.currentSolutionPage]
            ])
          }), 128))
        ]),
        (_ctx.solutionList.length > 6)
          ? (_openBlock(), _createBlock(_component_MyPage, {
              key: 0,
              pageSize: 6,
              total: _ctx.solutionList.length,
              currentPage: _ctx.currentSolutionPage,
              onChangePage: _ctx.changeCurrentPage
            }, null, 8, ["total", "currentPage", "onChangePage"]))
          : _createCommentVNode("", true),
        _createVNode(_component_CommonFooter)
      ]))
    : (_openBlock(), _createBlock(_component_DetailPage, {
        key: 1,
        onReturnList: _ctx.returnList
      }, null, 8, ["onReturnList"]))
}